// extracted by mini-css-extract-plugin
export default {"toggle-buttons-parent":"ToggleBudgetInput_toggle-buttons-parent__LiSX3","toggle-buttons":"ToggleBudgetInput_toggle-buttons__Biy2Z"};